<template>
  <dialog-info
    ref="dialog"
    :title="title"
    @close="handlerClose"
    customClass="dialog-connect-open-wo"
  >
    <list-form
      ref="list-form"
      :formModel="formModel"
      :config="config"
    >
      <template v-slot="{ data, item, autoSave}">
        <activity-item-wo
          :data="data"
          :item="item"
          :formModel="formModel"
          :autoSave="autoSave"
          @onSendEmail="handlerSendEmail"
          @updatedData="refresh"
        >
        </activity-item-wo>
      </template>
    </list-form>
  </dialog-info>
</template>

<script>
import { waitValue } from '@/utils/promises'
import { ModelOpenWO } from '@/models/RepairExchangeOrder'
import listFormConfig from './ListFormConfig'
export default {
  name: 'DialogConnectToOpenWO',
  components: {
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'activity-item-wo': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemOpenWO/Index')
  },
  props: {
    filterFieldName: { type: String, default: 'rfqid' },
    filterValueTemplate: {
      type: Function,
      default: (filterValue) => {
        return `rfqid == "${filterValue}"`
      }
    }
  },
  data () {
    return {
      filterValue: null,
      data: {},
      config: listFormConfig
    }
  },
  computed: {
    title () {
      return this.filterValue
    }
  },
  methods: {
    formModel () {
      return new ModelOpenWO()
    },
    refresh () {
      this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    async loadData () {
      try {
        const listForm = await this.getListForm()
        const filterExpression = await this.filterValueTemplate(this.filterValue)
        listForm.setFilters(filterExpression)
        return listForm.loadData()
      } catch (e) {
        this.$notify({
          type: 'error',
          message: e.message
        })
      }
    },
    show (data) {
      this.filterValue = data[this.filterFieldName]

      if (!this.filterValue) {
        return this.$notify({
          type: 'error',
          message: 'Unexpected behaviour'
        })
      }

      this.$refs['dialog'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    handlerClose () {
      this.getListForm()
        .then((listForm) => {
          listForm.clear()
        })
    },
    handlerSendEmail () {
      this.$emit('onSendEmail', ...arguments)
    }
  }
}
</script>
<style lang="stylus">
  .dialog-connect-open-wo.el-dialog{
    max-width 130rem
  }
</style>
